import { Utils } from "@/plugins/utils"
import router from '@/router';

export default {
	namespaced: true,
	state: {
		lstCv6: [],
		cv6: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false
	},
	getters: {
		getCv6Model(state) {
			let cv6 = { ...state.cv6 }
			cv6.cv6vigini = cv6.cv6vigini ? Utils.ParseToDate(cv6.cv6vigini) : new Date(1900, 1, 1)
			cv6.cv6vigfim = cv6.cv6vigfim ? Utils.ParseToDate(cv6.cv6vigfim) : new Date(1900, 1, 1)
			cv6.cv6limdesc = cv6.cv6limdesc ? parseFloat(cv6.cv6limdesc) : 0
			cv6.cv6limdesp = cv6.cv6limdesp ? parseFloat(cv6.cv6limdesp) : 0
			cv6.cv6percent = cv6.cv6percent ? parseFloat(cv6.cv6percent) : 0
			cv6.cv6limdias = cv6.cv6limdias ? parseInt(cv6.cv6limdias) : 0
			cv6.cv6limpraz = cv6.cv6limpraz ? parseInt(cv6.cv6limpraz) : 0
			cv6.cv6prazmax = cv6.cv6prazmax ? parseInt(cv6.cv6prazmax) : 0
			return cv6
		},
		getUpdate(state) {
			return state.update
		},
		getCv6lista(state) {
			return state.cv6.cv6lista
		},
		getSearch(state) {
			return state.search
		},
		getItemsPerPage(state) {
			return state.itemsPerPage
		},
	},
	mutations: {
		set(state, cv6) {
			state.cv6 = cv6
			if (cv6)
				state.cv6.cv6vigini = new Date(cv6.cv6vigini).toLocaleString(navigator.language, { year: "numeric", month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })
			state.cv6.cv6vigfim = new Date(cv6.cv6vigfim).toLocaleString(navigator.language, { year: "numeric", month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })
			state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.cv6 = null
		},
		setParamsDataTable(state, payload) {
			state.lstCv6 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setLoading(state, payload) {
			state.loading = payload
		},
		setCv6(state, payload) {
			state.cv6 = payload
		},
		setLstCv6(state, payload) {
			state.lstCv6 = payload
		},
		setSearch(state, payload) {
			state.search = payload
		},
	},
	actions: {
		initForm({ commit }) {
			commit("initForm")
		},
		async get({ dispatch }, cv6lista) {
			if (!cv6lista) {
				return null
			}
			return await this._vm.$axios
				.get(`/Price/PriceList/Find/${cv6lista}`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return null
				})
		},
		async find({ dispatch, commit }, cv6lista) {
			commit("setLoading", true)
			commit("initForm")
			await dispatch("get", cv6lista)
				.then(cv6 => {
					commit("set", cv6)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
				})
			commit("setLoading", false)
		},
		async save({ dispatch, getters }) {
			if (getters.getUpdate)
				return await dispatch("update")
			return await dispatch("insert")
		},
		async insert({ dispatch, getters, commit }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true }
			)
			let payload = await this._vm.$axios
				.post("/Price/PriceList/Insert", getters.getCv6Model)
				.then(response => {
					let res = Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/listas-de-preco/")
					commit("setCv6", null)
					return res
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async update({ dispatch, getters, commit }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true }
			)
			let payload = await this._vm.$axios
				.put("/Price/PriceList/Update", getters.getCv6Model)
				.then(response => {
					let res = Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/listas-de-preco/")
					commit("setCv6", null)
					return res
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async delete({ dispatch, getters }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true }
			)
			let payload = await this._vm.$axios
				.delete(`/Price/PriceList/Delete/${getters.getCv6lista}`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async findAll({ dispatch, commit }) {
			commit("setLoading", true)
			commit("initForm")
			let lstCv6 = await this._vm.$axios
				.get("/Price/PriceList/FindAll")
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return []
				})
			commit("setLoading", false)
			return lstCv6
		},
		async search({ commit, getters, dispatch }, { limit = 20, page = 1 }) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios
				.get(`/Price/PriceList/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setParamsDataTable", payload)
				})
				.catch(error => {
					commit("setLstCv6", [])
					commit("setSearch", "")
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
				})
			commit("setLoading", false)
		},
		async findPrices({ dispatch }, productSearchPriceRequestModel) {
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Consultando dados", indeterminate: true }, { root: true })
			let payload = await this._vm.$axios.post(`/Price/Price/Find`, productSearchPriceRequestModel)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data);
				})
				.catch((error) => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
					return null
				});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
	}
}
